module.exports = __webpack_public_path__ + "static/logo-99fa74e43a136bd0f18cbed7a6b39fb0.png";